export type BundledWasmExports = typeof import('./pkg/sew_mimic.js');

/**
 * Dynamically imports the wasm-bindgen bundle. Vite instantiates the WASM asset for us.
 */
export async function loadBundledSewMimicExports(): Promise<BundledWasmExports> {
	return import('./pkg/sew_mimic.js');
}

/**
 * Convenience helper to list function exports from an instantiated module export map.
 */
export function listFunctionExports(target: BundledWasmExports): string[] {
	return Object.entries(target)
		.filter(([, value]) => typeof value === 'function')
		.map(([name]) => name)
		.sort();
}
